import { Navigate } from 'react-router-dom'
import { RoleNotAvailable } from '@/auth/RequireAuth'
import { useCertAccess } from '@/lib/certs'

/**
 * What a technician sees on /field, which needs Supervisor.
 *
 * With certifications switched on for them: their own certifications, the
 * portal's first technician screen (design section 7). Otherwise the same
 * "not available" card as before -- shown while the answer is still loading
 * too, so an ungated technician's experience does not change at all.
 * /field itself is NOT widened; its screens stay Supervisor and up.
 */
export function TechnicianLanding() {
  const certs = useCertAccess()
  if (certs.loaded && certs.enabled && certs.can('view_own')) {
    return <Navigate to="/certs/mine" replace />
  }
  return <RoleNotAvailable role="Supervisor" />
}
